/** Plan price arithmetic shared by the plan table and the offline fallback. */

/** Whole-percent saving of paying annually versus twelve monthly payments (0 if none). */
export function annualSavingPercent(monthlyPrice: number, annualPrice: number): number {
  const fullYear = monthlyPrice * 12;
  if (fullYear <= 0 || annualPrice >= fullYear) return 0;
  return Math.round((1 - annualPrice / fullYear) * 100);
}

/** Only Discord invites are shown as the Founders link (the server checks it too). */
export function isDiscordUrl(url: string | null | undefined): url is string {
  return !!url && /^https:\/\/(discord\.gg|discord\.com)\//.test(url) && !/[\s<>"']/.test(url);
}
